export const deClientPortalValuationIncomePage = {
    formulas: {
        grossInitialYield: '\\frac{\\text{Vertragsmiete} \\times 100}{\\text{Marktwert}}',
        grossYield: '\\frac{\\text{Marktmiete} \\times 100}{\\text{Marktwert}}',
        grossYieldMultiplier: '\\frac{\\text{Marktwert}}{\\text{Rohertrag}}',
        netYieldMultiplier: '\\frac{\\text{Marktwert}}{\\text{Reinertrag}}',
    },
    sensitivityMatrix: {
        infoTitle: 'Rundung',
        infoText: 'Die Ergebnisse werden in der Sensitivitätsmatrix ungerundet dargestellt, um Verzerrungen zu vermeiden.',
        legendLabel: 'Legende',
        deltaToMarketValue: 'Delta zum Marktwert',
        capitalValue: 'Kapitalwert',
        actualMultiplier: 'Multiplikator IST',
        actualGrossInitialYield: 'Bruttoanf.-Rendite IST',
    },
}
